import * as types from '../actions/ActionTypes';

const INITIAL_STATE = {
  orgFilteredData: false,
  peopleFilteredData: null,
  lotsFilteredData: null,
  searchTerm: ''
};

export function filterReducer(state = INITIAL_STATE, action) {
  const { payload, type } = action;
  switch (type) {
    case types.SET_ORG_FILTERED_DATA: {
      return {
        ...state,
        orgFilteredData: payload
      };
    }
    case types.SET_PEOPLE_FILTERED_DATA: {
      return {
        ...state,
        peopleFilteredData: payload
      };
    }
    case types.SET_LOTS_FILTERED_DATA:
      return {
        ...state,
        lotsFilteredData: payload
      };
    case types.SET_SEARCH_TERM:
      return {
        ...state,
        searchTerm: payload
      };
    case types.CLEAR_SEARCH_TERM:
      return {
        ...state,
        searchTerm: ''
      };
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/filter.reducer.js